"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
import { Users, Briefcase, Star, TrendingUp, Clock, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
const vehicles = [{
  id: 1,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-May-5-2026-04_42_08-PM.png",
  make: "Lincoln",
  model: "MKT Stretch Limousine",
  capacity: "8–10 Passengers",
  useCases: "Weddings, proms, night out",
  features: "Fiber optic lighting, bar service, privacy partition",
  businessValue: "Classic luxury for special events",
  minimum: "4–6 hours",
  description: "different picture and information"
}, {
  id: 2,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-May-5-2026-04_48_03-PM.png",
  make: "Hummer\xA0 Limousine",
  model: "\xA0Stretch\xA0 \xA0Limousine",
  capacity: "14–18 Passengers",
  useCases: "Bachelor parties, large group celebrations",
  features: "Premium sound system, multiple TV screens, disco floor",
  businessValue: "High-demand for large party groups",
  minimum: "5–8 hours",
  description: "different picture and information"
}, {
  id: 3,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-May-5-2026-05_02_34-PM.png",
  make: "Hummer",
  model: "H2 Super Stretch",
  capacity: "18–22 Passengers",
  useCases: "Concerts, sporting events, large parties",
  features: "Rugged exterior, spacious interior, neon lighting",
  businessValue: "Iconic presence for high-profile events",
  minimum: "6–8 hours",
  description: "different picture and information"
}, {
  id: 4,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-May-5-2026-05_09_21-PM.png",
  make: "Mercedes-Benz",
  model: "Sprinter Limo Van",
  capacity: "10–14 Passengers",
  useCases: "Corporate retreats, wine tours, VIP transport",
  features: "Standing room, luxury captain chairs, high ceiling",
  businessValue: "Versatile and highly profitable",
  minimum: "5–8 hours",
  description: "different picture and information"
}, {
  id: 5,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-May-5-2026-07_29_29-PM.png",
  make: "BMW",
  model: "7 Series Executive",
  capacity: "2–3 Passengers",
  useCases: "Executive travel, airport transfers",
  features: "Rear-seat entertainment, climate control, smooth ride",
  businessValue: "Perfect for corporate contracts",
  minimum: "2–4 hours",
  description: "different picture and information"
}, {
  id: 6,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-May-5-2026-05_29_43-PM.png",
  make: "Chevrolet\xA0",
  model: "chevrolet suburban",
  capacity: "6–7 Passengers",
  useCases: "Family travel, airport runs, small groups",
  features: "Extra luggage space, premium leather, 4WD",
  businessValue: "Reliable workhorse for daily operations",
  minimum: "3–5 hours",
  description: "different picture and information"
}, {
  id: 7,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-May-5-2026-05_18_09-PM.png",
  make: "Mini Coach Bus",
  model: "Executive Party Bus",
  capacity: "25–30 Passengers",
  useCases: "Corporate events, large weddings",
  features: "Dance pole, restroom, full bar, lounge seating",
  businessValue: "Maximum revenue per booking",
  minimum: "6–8 hours",
  description: "different picture and information"
}, {
  id: 8,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-May-5-2026-05_13_51-PM.png",
  make: "Rolls-Royce",
  model: "Phantom (Vintage)",
  capacity: "2–3 Passengers",
  useCases: "Wedding getaway car, photo shoots",
  features: "Classic styling, wool carpets, wood trim",
  businessValue: "Premium niche for luxury weddings",
  minimum: "4 hours",
  description: "different picture and information",
  makeClassName: "absolute bottom-0 left-0 right-0 bg-black/80 backdrop-blur-xl border-t border-white/10 p-6 translate-y-full group-hover:translate-y-0 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-smooth)] !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-May-3-2026-11_30_07-PM.png)]"
}, {
  id: 9,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-May-5-2026-04_33_35-PM.png",
  make: "Tesla",
  model: "Model X",
  capacity: "4–5 Passengers",
  useCases: "Eco-conscious VIPs, tech executives",
  features: "Falcon wing doors, silent electric drive, autopilot",
  businessValue: "Modern appeal for green-focused clients",
  minimum: "3–5 hours",
  description: "different picture and information"
}, {
  id: 10,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-May-5-2026-05_36_03-PM.png",
  make: "Ford",
  model: "F-550 Mini Coach",
  capacity: "30–35 Passengers",
  useCases: "Shuttle services, long-distance group travel",
  features: "Reclining seats, overhead storage, PA system",
  businessValue: "Ideal for high-volume group transport",
  minimum: "5–8 hours",
  description: "different picture and information"
}];
export default function VehicleGallery() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref4,
    isVisible: isVisible4
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref5,
    isVisible: isVisible5
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref6,
    isVisible: isVisible6
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref7,
    isVisible: isVisible7
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref8,
    isVisible: isVisible8
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref9,
    isVisible: isVisible9
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref10,
    isVisible: isVisible10
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref11,
    isVisible: isVisible11
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref12,
    isVisible: isVisible12
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const refs = [ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12];
  const visibilities = [isVisible1, isVisible2, isVisible3, isVisible4, isVisible5, isVisible6, isVisible7, isVisible8, isVisible9, isVisible10, isVisible11, isVisible12];
  return <section id="vehicle-gallery" className="dark bg-background text-foreground section-padding px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-display mb-4 tracking-tight">
            Our Premium Fleet
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
            Discover our collection of luxury sedans and SUVs, meticulously maintained for your comfort and style
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {vehicles.map((vehicle, i) => <div key={vehicle.id} data-index={i} ref={refs[i]} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <Card className={`${vehicle.imageClassName || ""} group relative overflow-hidden glass-effect border-secondary/30 hover:border-secondary transition-all duration-[var(--duration-medium)] p-0 shadow-medium hover:shadow-strong min-h-[500px]`}>
                <div className="relative h-full overflow-hidden">
                  <img src={vehicle.image} data-wvc-srcset={`${vehicle.image}-wvc-srcset`} data-wvc-sizes={`${vehicle.image}-wvc-sizes`} alt={`${vehicle.make} ${vehicle.model}`} loading="lazy" className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-[1.02]" />
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}